export default __webpack_public_path__ + "static/media/LinieGelb.7f69336e.svg";